import React from "react";
import Header from "../../components/Header";
import { IconButton } from "@mui/material";
import TextField from "../../components/TextField";
import { COMPONENT_ERROR_TEXT, subformInputChange } from "../../utils";
import { v4 as uuidv4 } from "uuid";
import DeleteIcon from "@mui/icons-material/Delete";
import { Card, Flex } from "antd";
// import Dropdown from "../../components/Dropdown";
import CustomAutocomplete from "../../components/Autocomplete";

const PlatformUserLogin = ({
  data,
  setData,
  error,
  setError,
  handleInputChange,
  disabled,
  btnLoading,
}) => {
  // Filter branches to only include those with actual data
  const validBranches = data?.list_of_branches?.filter(item => {
    // Keep head office branch
    if (item.key === "head-office") return true;
    // Keep branches that have at least a name, address, or city
    return item.branch_name || item.address || item.city;
  }) || [];

  let branch_city_options = validBranches.length > 0
    ? validBranches.map((item) => {
        return {
          label: `${item?.branch_name} - ${item?.address}, ${
            item?.line2 ? `${item?.line2},` : ""
          } ${item?.city}, ${item?.province}, ${item?.country} - ${
            item?.postal_code
          }`,
          value: `${item?.branch_name} - ${item?.address}, ${
            item?.line2 ? `${item?.line2},` : ""
          } ${item?.city}, ${item?.province}, ${item?.country} - ${
            item?.postal_code
          }`,
        };
      })
    : [];

  return (
    <div>
      <Header text="Platform Broker Logins" />

      <div className="form_container">
        <Flex gap={32} align="center" className="mb_16">
          <p className="label">User Accounts</p>
          {/* <button
            className="next_btn subform_add_btn"
            onClick={() => {
              let undefined_check_error = error.user_accounts.some((item) => {
                return Object.values(item).some((value) => value === undefined);
              });

              if (undefined_check_error) {
                let copy_error = { ...error };

                copy_error.user_accounts.map((item) => {
                  for (const key in item) {
                    if (item[key] === undefined) {
                      item[key] = true;
                    }
                  }
                });

                setError(copy_error);
                return;
              }

              let true_check_error = error.user_accounts.some((item) => {
                return Object.values(item).some((value) => value === true);
              });

              if (true_check_error) {
                return;
              }

              let key = uuidv4();

              setData({
                ...data,
                user_accounts: [
                  ...data?.user_accounts,
                  {
                    key,
                    first_name: "",
                    last_name: "",
                    email: "",
                    title: "",
                    branch_city: "",
                  },
                ],
              });

              setError({
                ...error,
                user_accounts: [
                  ...error?.user_accounts,
                  {
                    key,
                    first_name: undefined,
                    last_name: undefined,
                    email: undefined,
                    title: undefined,
                    branch_city: undefined,
                  },
                ],
              });
            }}
            disabled={disabled?.stage || btnLoading}
          >
            Add user
          </button> */}
        </Flex>

        <Flex vertical gap={32}>
          {data?.user_accounts.map((item, index) => {
            return (
              <Card
                title={
                  <p>
                    Broker #{index + 1}{" "}
                    {Object.values(error.user_accounts[index]).some(
                      (value) => value === true
                    ) ? (
                      <span className="subform_error_text">
                        {COMPONENT_ERROR_TEXT}
                      </span>
                    ) : (
                      ""
                    )}
                  </p>
                }
                size="small"
                key={index}
                extra={
                  <IconButton
                    onClick={() => {
                      let filter = data?.user_accounts.filter(
                        (i) => item?.key !== i?.key
                      );

                      let error_filter = error?.user_accounts.filter(
                        (i) => item?.key !== i?.key
                      );

                      if (filter.length === 0) {
                        return;
                      }

                      setError({ ...error, user_accounts: error_filter });
                      setData({ ...data, user_accounts: filter });
                    }}
                    disabled={
                      data?.user_accounts.length === 1 ||
                      disabled?.stage ||
                      btnLoading
                    }
                  >
                    <DeleteIcon
                      style={{ fontSize: "1.25rem", color: "#fb7d7f" }}
                    />
                  </IconButton>
                }
              >
                <div className="form_container" style={{ padding: "0" }}>
                  <TextField
                    size="middle"
                    label="First Name"
                    handleChange={(e) =>
                      subformInputChange({
                        value: e.target.value,
                        name: e.target.name,
                        object_key: "user_accounts",
                        key: item?.key,
                        data: data,
                        setData: setData,
                        error: error,
                        setError: setError,
                      })
                    }
                    name="first_name"
                    value={item?.first_name}
                    required
                    error_state={error?.user_accounts[index]?.first_name}
                    disabled={disabled?.stage || btnLoading}
                  />{" "}
                  <TextField
                    size="middle"
                    label="Last Name"
                    handleChange={(e) =>
                      subformInputChange({
                        value: e.target.value,
                        name: e.target.name,
                        object_key: "user_accounts",
                        key: item?.key,
                        data: data,
                        setData: setData,
                        error: error,
                        setError: setError,
                      })
                    }
                    name="last_name"
                    value={item?.last_name}
                    required
                    error_state={error?.user_accounts[index]?.last_name}
                    disabled={disabled?.stage || btnLoading}
                  />
                  <TextField
                    label="Email"
                    name="email"
                    value={item?.email}
                    handleChange={(e) =>
                      subformInputChange({
                        value: e.target.value,
                        name: e.target.name,
                        object_key: "user_accounts",
                        key: item?.key,
                        data: data,
                        setData: setData,
                        error: error,
                        setError: setError,
                        custom: "email",
                      })
                    }
                    required
                    size="middle"
                    error_state={error?.user_accounts[index]?.email}
                    disabled={disabled?.stage || btnLoading}
                  />
                  <TextField
                    label="Title"
                    name="title"
                    value={item?.title}
                    handleChange={(e) =>
                      subformInputChange({
                        value: e.target.value,
                        name: e.target.name,
                        object_key: "user_accounts",
                        key: item?.key,
                        data: data,
                        setData: setData,
                        error: error,
                        setError: setError,
                      })
                    }
                    required
                    size="middle"
                    error_state={error?.user_accounts[index]?.title}
                    disabled={disabled?.stage || btnLoading}
                  />
                  <CustomAutocomplete
                    size="middle"
                    label="Branch City"
                    name="branch_city"
                    value={item?.branch_city}
                    options={branch_city_options}
                    handleChange={(value) =>
                      subformInputChange({
                        value: value,
                        name: "branch_city",
                        object_key: "user_accounts",
                        key: item?.key,
                        data: data,
                        setData: setData,
                        error: error,
                        setError: setError,
                      })
                    }
                    error_state={error?.user_accounts[index]?.branch_city}
                    required
                    disabled={disabled?.stage || btnLoading}
                  />
                </div>
              </Card>
            );
          })}
        </Flex>
        {/* //added by Krishnaja */}
        <>
        <button
            className="next_btn subform_add_btn"
            onClick={() => {
              let undefined_check_error = error.user_accounts.some((item) => {
                return Object.values(item).some((value) => value === undefined);
              });

              if (undefined_check_error) {
                let copy_error = { ...error };

                copy_error.user_accounts.map((item) => {
                  for (const key in item) {
                    if (item[key] === undefined) {
                      item[key] = true;
                    }
                  }
                });

                setError(copy_error);
                return;
              }

              let true_check_error = error.user_accounts.some((item) => {
                return Object.values(item).some((value) => value === true);
              });

              if (true_check_error) {
                return;
              }

              let key = uuidv4();

              setData({
                ...data,
                user_accounts: [
                  ...data?.user_accounts,
                  {
                    key,
                    first_name: "",
                    last_name: "",
                    email: "",
                    title: "",
                    branch_city: "",
                  },
                ],
              });

              setError({
                ...error,
                user_accounts: [
                  ...error?.user_accounts,
                  {
                    key,
                    first_name: undefined,
                    last_name: undefined,
                    email: undefined,
                    title: undefined,
                    branch_city: undefined,
                  },
                ],
              });
            }}
            disabled={disabled?.stage || btnLoading}
          >
            Add user
          </button>
        </>
      </div>
    </div>
  );
};

export default PlatformUserLogin;
